import { useState } from "react";
import Menu from "../Menu/Menu";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { HiArrowNarrowLeft, HiMenu } from "react-icons/hi";

//해더
const Header = ({ title, isDirectAccess, goBack }) => {
  const [showMenu, setShowMenu] = useState(false);
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (goBack) {
      goBack();
    } else {
      navigate(-1);
    }
  };

  const channelId = useSelector((state) => state.checkArsStatus.channelId);
  const brandId = useSelector((state) => state.checkArsStatus.brandId);

  return (
    <>
      <header className={`fixed top-0 left-0 z-50 w-full h-[4.5rem] bg-brand-primary p-inner flex items-center justify-center text-brand-text`}>
        {channelId && !isDirectAccess && (
          <button
            className="absolute flex items-center justify-start w-12 h-12 transform -translate-y-1/2 left-3 top-1/2"
            onClick={handleGoBack}
          >
            <HiArrowNarrowLeft className="text-3xl" />
          </button>
        )}
        <h1 className="text-[1.375rem] font-semibold px-8 truncate">
          {title}
        </h1>

        {(channelId && !isDirectAccess && brandId !== "LD") && (
          <button
            className="absolute flex items-center justify-end w-12 h-12 transform -translate-y-1/2 right-3 top-1/2 "
            onClick={toggleMenu}
          >
            <HiMenu className="text-3xl" />
          </button>
        )}
      </header>
      <Menu show={showMenu} onClose={() => setShowMenu(false)} />
    </>
  );
};

export default Header;
